import { render, staticRenderFns } from "./WashHands.vue?vue&type=template&id=5eed7a89&scoped=true&"
import script from "./WashHands.vue?vue&type=script&lang=js&"
export * from "./WashHands.vue?vue&type=script&lang=js&"
import style0 from "./WashHands.vue?vue&type=style&index=0&id=5eed7a89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eed7a89",
  null
  
)

export default component.exports